import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { guardConfig } from '~/organizer/shared/configs/guard.config';

@Injectable({
  providedIn: 'root',
})
export abstract class OrganizerSharedAbstractGuard {
  protected abstract readonly errorCode: ErrorCodesEnum;

  protected constructor(
    protected readonly errorCodeService: ErrorCodeService,
    protected readonly router: Router
  ) {}

  protected catchError(): Promise<boolean> {
    this.errorCodeService.pushCode(this.errorCode);

    return this.router.navigateByUrl(guardConfig.invalidRedirectionPath);
  }

  protected redirectInvalid(): UrlTree {
    this.errorCodeService.pushCode(this.errorCode);

    return this.router.parseUrl(guardConfig.invalidRedirectionPath);
  }
}
